import { useCallback, useState, useEffect } from "react"

export function useWindowDimensions() {
  const hasWindow = typeof window !== "undefined"

  const [windowDimensions, setWindowDimensions] = useState({
    width: hasWindow ? window.innerWidth : null,
    height: hasWindow ? window.innerHeight : null,
  })

  const [breakpoint, setBreakpoint] = useState(findBreakpoint(hasWindow ? window.innerWidth : null))

  const handleResize = useCallback(() => {
    setWindowDimensions({
      width: hasWindow ? window.innerWidth : null,
      height: hasWindow ? window.innerHeight : null,
    })
    setBreakpoint(findBreakpoint(hasWindow ? window.innerWidth : null))
  }, [hasWindow])

  useEffect(() => {
    if (hasWindow) {
      window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
    }
  }, [hasWindow, handleResize])

  return { ...windowDimensions, breakpoint }
}

const findBreakpoint = (width) => {
  if (width == null) return null

  if (width >= 1536) {
    return "2xl"
  } else if (width >= 1280) {
    return "xl"
  } else if (width >= 1024) {
    return "lg"
  } else if (width >= 768) {
    return "md"
  } else if (width >= 640) {
    return "sm"
  } else {
    return ""
  }
}
